module.exports = __webpack_public_path__ + "img/wban-logo-polygon.648920a6.svg";